/****************************************************************
 * Js imports
 ****************************************************************/

/****************************************************************
* CODE collectionNav
****************************************************************/
/*!
 * getParameterByName.min.js
 */

function getParameterByName(e, n) {
  n || (n = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
  var r = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(n);
  return r ? r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "" : null;
}

!function ($, document, window, undefined) {
  /**
  * Plugin name
  */
  var _pluginName = 'collectionNav';
  /**
  * @param $element Element Wrapping container div
  * @param options Options passed to public functions
  * @return collectionNav_plugin
  */

  var collectionNav_plugin = function collectionNav_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element;
    self.storageId = 'CodeCollectionNav';
    self.parameters = [];
    self.sort_by = getParameterByName('sort_by');
    self.view = getParameterByName('view');
    self.page = parseInt(getParameterByName('page')); // collection sorter

    self.$element.find('[data-sort-collection]').each(function () {
      // set to current sorting
      var sortingData = $(this).data('sort-collection');

      if (sortingData.current != 'undefined') {
        $(this).find('[value="' + sortingData.current + '"]').prop('selected', true);
      }
    }); // init collection sorter

    self.$element.on('change', '[data-sort-collection]', function (event) {
      // on change, reload with sorting parameter
      event.preventDefault();
      //console.log('[data-sort-collection] change event'); // get current values

      var parameters = window.location.search; // Check on content and ?

      if (parameters != '' && parameters.includes('?')) {
        // Get the string after the ? and split on possible &
        var items = parameters.split('?')[1].split('&'); // Loop over array with parameters

        for (var i = 0; i < items.length; i++) {
          // Set current parameter
          var item = items[i];

          if (item.includes('=')) {
            self.parameters.push(item);
          }
        }
      }

      var sortingData = $(this).data('sort-collection');
      var newSorting = $(this).val();
      self.sort_by = ''; // reset paging

      self.page = '';

      if (newSorting != sortingData.default) {
        self.sort_by = newSorting;
      }

      self.goToUrl();
    }); // init collection grid/list view

    self.$element.on('change', '[data-collection-view]', function (event) {
      // on change, reload page with viewing parameter
      event.preventDefault();
      var newView = $(this).val();
      self.view = newView;
      self.goToUrl();
    }); // init collection paging

    self.$element.on('click', '[data-collection-nav-paging] a', function (event) {
      event.preventDefault(); // on change, reload page with page parameter

      var newPageUrl = $(this).attr('href');
      self.page = parseInt(getParameterByName('page', newPageUrl));
      self.goToUrl();
    }); // THIS DOES NOT WORK WITH FILTERED COLLECTIONS

    if ($.localStorage) {
      // get stored collection objects from localstorage
      self.getCollectionsNav(); // find links that point to this collection

      self.$element.find('[data-collection-nav-link]').each(function () {
        // get url of collection
        var url = $(this).data('collection-nav-link'); // check if localstorage contains params for this url

        var urlData = self.collectionsParams[url];

        if (!urlData) {
          return;
        } // create new url


        var newUrl;

        if (urlData && urlData.view) {
          newUrl = self.addtoUrl(url, 'view', urlData.view);
        }

        if (urlData && urlData.sort_by) {
          newUrl = self.addtoUrl(newUrl, 'sort_by', urlData.sort_by);
        }

        if (urlData && urlData.page) {
          newUrl = self.addtoUrl(newUrl, 'page', urlData.page);
        } // update href with newUrl


        if (newUrl) {
          $(this).attr('href', newUrl);
        }
      });
    }
  };
  /**
  * Toggle nav
  */


  collectionNav_plugin.prototype.addtoUrl = function (url, param, val) {
    var q = '';

    if (val) {
      if (url.indexOf('?') < 0) {
        q = '?';
      } else {
        q = '&';
      }

      url += q + param + '=' + val;
    }

    return url;
  };
  /**
  * Go To Url
  */


  collectionNav_plugin.prototype.goToUrl = function () {
    var self = this;
    var path = window.location.pathname;
    var url = window.location.protocol + "//" + window.location.host + path;
    self.storeCollectionsNav(path);
    var newUrl = self.addtoUrl(url, 'view', self.view);
    newUrl = self.addtoUrl(newUrl, 'sort_by', self.sort_by);
    newUrl = self.addtoUrl(newUrl, 'page', self.page); // Check for other existing parameters and add it to the url

    if (self.parameters.length > 0) {
      for (var i = 0; i < self.parameters.length; i++) {
        var item = self.parameters[i];

        if (item.includes('=') && !item.includes('view=') && !item.includes('sort_by=') && !item.includes('page=')) {
          item = item.split('=');
          newUrl = self.addtoUrl(newUrl, item[0], item[1]);
        }
      }
    } // go to url


    window.location = newUrl;
  };
  /**
  * get collections nav objects
  */


  collectionNav_plugin.prototype.getCollectionsNav = function () {
    var self = this;

    if ($.localStorage) {
      // get stored collection objects from localstorage
      self.collectionsParams = {};
      var storedCollectionsParams = localStorage.getItem(self.storageId);

      if (storedCollectionsParams) {
        self.collectionsParams = JSON.parse(storedCollectionsParams);
      }
    }
  };
  /**
  * Store collections nav objects
  */


  collectionNav_plugin.prototype.storeCollectionsNav = function (url) {
    var self = this;

    if ($.localStorage) {
      // get stored collection objects from localstorage
      self.getCollectionsNav(); // add current / update the collection object in collection objects

      self.collectionsParams[url] = {
        page: self.page,
        view: self.view,
        sort_by: self.sort_by
      }; // store the collection objects

      localStorage.setItem(self.storageId, JSON.stringify(self.collectionsParams));
    }
  };
  /**
  * collectionNav plugin
  *
  * @return jQuery objects
  */


  $.fn.collectionNav = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collectionNav_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
* CODE Filters
****************************************************************/

var storageUrlId = 'CodeFilterBackUrl';
!function ($, document, window, undefined) {
  /**
  * Plugin name
  *
  * @var string
  */
  var _pluginName = 'collectionFiltering';
  /**
  * Constructor collectionFiltering_plugin
  *
  * @param $element Element Wrapping container div
  * @param options Options passed to public functions
  * @return collectionFiltering_plugin
  */

  var collectionFiltering_plugin = function collectionFiltering_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element;
    self.storagePanesId = false;
    self.storageUrlId = false; // Create local storage ID's

    if ($.localStorage) {
      self.storagePanesId = 'CodeFilterPanesState';
      self.storageUrlId = storageUrlId;
    } // Init


    self.init();
  };
  /**
  * init
  *
  * @access public
  * @return void
  */


  collectionFiltering_plugin.prototype.init = function () {
    var self = this; // Create ajax url from current url

    var path = window.location.pathname;
    path = path.substr(path.indexOf('collections'));
    var ajaxFilterUrl = "/" + path + '?view=filters-ajax';

    if ($.debug) {
      //console.log('Filter init:', window.location.protocol + "//" + window.location.host + ajaxFilterUrl);
    } // Find the filter wrapper


    self.$filterWrapper = $('#filters [data-filter-wrapper]'); // Get filter data from ajax

    $.get(ajaxFilterUrl).done(function (dataReceived) {
      // Remove comments
      dataReceived = dataReceived.replace(/<!--[\s\S]*?-->/g, ""); // Render filters

      self.render(dataReceived);
    });

      // Catch change of radio inputs
    self.$element.on('change', 'input[type="checkbox"]', function () {
      // uncheck all others in this list
      $(this).closest('[data-key-filter]').find('input[type="checkbox"]').not(this).prop('checked', false); // Update url url parameters.

      self.updateUrl();
    }); // catch click on 'remove a filter'.

    self.$element.on('click', '[data-remove-tag]', function (event) {
      event.preventDefault(); // uncheck the checkbox

      var removeTagValue = $(this).data('remove-tag');
      self.$element.find('.filter-pane input[type="checkbox"][value="' + removeTagValue + '"]').prop('checked', false); // update url

      self.updateUrl();
    }); // catch click on 'clear all'

    self.$element.on('click', '[data-filter-clear_all]', function (event) {
      event.preventDefault(); // uncheck all radio's

      self.$element.find('.filter-pane input[type="checkbox"]').prop('checked', false); // update url to nothing

      self.updateUrl();
    }); // If localstorage

    if ($.localStorage) {
      // Catch click on open/close filter panes
      self.$element.on('click', '[data-collapsible-trigger], [data-collapsible-trigger-icon]', function () {
        // get current state
        self.filterState = {};
        self.$element.find('[data-filter]').each(function (i, el) {
          var name = $(el).data('filter');
          self.filterState[name] = $(el).hasClass('collapsible__is-open');
        });
        self.$element.find('[data-filter-list]').each(function (i, el) {
          var name = $(el).data('filter-list');
          self.filterState[name] = $(el).hasClass('collapsible__is-open');
        }); // Store state in localstorage

        localStorage.setItem(self.storagePanesId, JSON.stringify(self.filterState));
      });
    }
  };
  /**
  * Render filters
  *
  * @access public
  * @return void
  */


  collectionFiltering_plugin.prototype.render = function (html) {
    var self = this;

    if ($.debug) {
      //console.log('Filter data received:', $(html));
    }

    if (!$(html).children().length) {
      return;
    }

    var $filterHtml = $(html).children(); // get options from html

    self.options = $filterHtml.data('filter-options'); // Remove existing filters

    self.$filterWrapper.find('.filter-ajax').remove(); // Add filters html to pane

    self.$filterWrapper.append($filterHtml); // set state of collapsible panes from local storage

    self.setTabState(); // Show the element

    self.$element.find('.filter-load-wrapper:first').removeClass('filter-load-wrapper');
  };
  /**
  * Get state of Tabs
  *
  * @access public
  * @return void
  */


  collectionFiltering_plugin.prototype.setTabState = function () {
    var self = this; // Get tabs state from localstorage

    var backLinkData = localStorage.getItem(self.storagePanesId);

    if ($.localStorage && backLinkData) {
      self.filterState = JSON.parse(backLinkData); // Apply state to tabs

      $.each(self.filterState, function (name, isOpen) {
        var $pane = self.$element.find('[data-filter="' + name + '"]');

        if (name.indexOf('-list') > -1) {
          $pane = self.$element.find('[data-filter-list="' + name + '"]');
        }

        if (isOpen) {
          // Open the tab
          $pane.addClass('collapsible__is-open');
        } else {
          // Unless checked checkboxes
          if ($pane.find('input:checked').length > 0) {
            $pane.addClass('collapsible__is-open');
          } else {
            // Close the tab
            $pane.removeClass('collapsible__is-open');
          }
        }
      });
    }
  };
  /**
  * Update URL
  * Update the url with a given query.
  *
  * @access public
  * @return void
  */


  collectionFiltering_plugin.prototype.updateUrl = function () {
    var self = this; // Loop over the checked radios to build url Query

    var urlQuery = []; // loop all checked inputs

    self.$element.find('.filter-pane input[type="checkbox"]:checked').each(function () {
      var value = $(this).val();

      if (urlQuery.indexOf(value) === -1) {
        urlQuery.push(value);
      }
    });
    urlQuery = urlQuery.join('+'); // Create path from current url

    var path = window.location.pathname;
    path = path.substr(path.indexOf('collections'));
    var paths = path.split("/");
    var page = 1;
    var current_page = getParameterByName('page');

    if (current_page != page) {
      page = current_page;
    }

    var view = 'grid';
    var current_view = getParameterByName('view');

    if (current_view != view) {
      view = current_view;
    }

    var sort_by = 'grid';
    var current_sort_by = getParameterByName('sort_by');

    if (current_sort_by != sort_by) {
      sort_by = current_sort_by;
    }

    if ($.localStorage) {
      // Store Url in storage so the Product Detail Page Back link can use it
      localStorage.setItem(self.storageUrlId, JSON.stringify({
        url: urlQuery,
        collection: paths[1],
        page: page,
        view: view,
        sort_by: sort_by
      }));
    } // create new url


    var filterUrl = "/" + paths[0] + '/' + paths[1] + '/' + urlQuery; // add view and sort_by to url (ignore paging)

    filterUrl = self.addtoUrl(filterUrl, 'view', view);
    filterUrl = self.addtoUrl(filterUrl, 'sort_by', sort_by);

    if ($.debug) {
      //console.log('Filter update Url:', window.location.protocol + "//" + window.location.host + filterUrl);
    }

    window.location.href = filterUrl;
  };
  /**
  * Add param to url
  *
  * @return {string} [url]
  */


  collectionFiltering_plugin.prototype.addtoUrl = function (url, param, val) {
    var q = '';

    if (val) {
      if (url.indexOf('?') < 0) {
        q = '?';
      } else {
        q = '&';
      }

      url += q + param + '=' + val;
    }

    return url;
  };
  /**
  * collectionFiltering plugin
  *
  * @return jQuery objects
  */


  $.fn.collectionFiltering = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collectionFiltering_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
$(document).ready(function () {
  // Init filters
  $('#filters').collectionFiltering(); // Get filter url data

  var backLinkData = localStorage.getItem(storageUrlId);

  if (backLinkData) {
    backLinkData = JSON.parse(backLinkData); // Find backlink on product detail page

    var $backLink = $('[data-filter="backlink"]'); // if we are on product detail page

    if ($backLink.length) {
      var backUrl = $backLink.attr('href');
      var backUrlCollection = backUrl.replace('/collections/', ''); // If backlink goes to the collection we filtered last time, apply the filtering and paging to the url

      if (backUrlCollection == backLinkData.collection) {
        var pager = '';

        if (backLinkData.page > 1) {
          pager = '?page=' + backLinkData.page;
        } // change url of product backlink to include the filter parameters


        $backLink.attr('href', '/' + backLinkData.url + pager);
      }
    }
  } // if we are on a collection page


  if ($('#filters').length) {
    var current_page = getParameterByName('page') || 1; // if data exists

    if (backLinkData) {
      // get page from data
      var page = parseInt(backLinkData.page); // if we changed page

      if (current_page != page) {
        // Store Url in storage so the Product Detail Page Back link can use it
        localStorage.setItem(storageUrlId, JSON.stringify({
          url: backLinkData.url,
          collection: backLinkData.collection,
          page: current_page
        }));
      }
    } else {
      var path = window.location.pathname;
      path = path.substr(path.indexOf('collections'));
      var paths = path.split("/");
      var page_current = getParameterByName('page');
      var collection = paths[1]; // Store Url in storage so the Product Detail Page Back link can use it

      localStorage.setItem(storageUrlId, JSON.stringify({
        url: path,
        collection: collection,
        page: page_current
      }));
    }
  }
}).on('shopify:section:load', function (e) {
  var $parentSection = $('#shopify-section-' + e.detail.sectionId); // Filter: init

  if ($parentSection.hasClass('filter-section')) {
    $('#filters').collectionFiltering('init');
  }
});
/****************************************************************
 * CODE ajaxPagination
 *
 ****************************************************************/
// const { data } = require("jquery");


/****************************************************************
* CODE collectionFilter
****************************************************************/

!function ($, document, window, undefined) {
  /**
  * Plugin name
  */
  var _pluginName = 'collectionFilter';
  /**
  * @param jQuery Element Wrapping container div
  * @return collectionFilter_plugin
  */

  var collectionFilter_plugin = function collectionFilter_plugin($element, options) {
    // scope it
    var self = this; // Get needed elements

    self.$element = $element;
    self.$filters = self.$element.data('filter-wrapper');
    self.$checkboxesContainer = self.$element.find('.collection-filter__group-checkbox');
    self.$collections = $('.collections-all-products-section');
    self.$products = self.$collections.find('.product-link-wrapper');
    self.$clearAllButton = $('[data-collection-filter-reset]'); // Get needed Global variables
    self.$closeFilter = $('.close-filter');
    self.$closeFilterOverlay = $('.PageOverlay');
    self.$filterClasses = self.$element.data('collection-filter-classes').split(',');
    self.$pointsNeeded = 0;
    self.$selectedTags = [];
    self.$checkedFilters = [];
    self.$paramObj = {};

    if (1) {
      //console.log('Init collectionFilter:', self.$element);
      //console.log('Filters categories:', self.$filterClasses);
    } // Start the collectionFilter


    self.init(); // connect on newProductsLoaded;

    self.$element.on('productsLoaded', function (e) {
      self.$products = self.$collections.find('.product-link-wrapper');
      self.init();
    });
  };
  /**
  * Init
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.init = function () {
    var self = this; // Check Url params and check the correct checkbox.

    self.initLinkedProducts();
    self.readUrlParams(); // Loop all Filter input[type"checkbox"]'s

    self.$checkboxesContainer.each(function (i, checkbox) {
      // Connect onChange to Filter input[type"checkbox"]'s
      $(checkbox).on('change', function (event) {
        // Handle onChange event
        self.checkCheckedInputs();
        self.updateProductPoints();
        self.updateCollectionPoints();
        self.updateUrl();
      });
    });
    $(window).on('resize', function (event) {
      // Handle onChange event
      self.updateCollectionPoints();
    });
    self.$closeFilter.on('click', function () {
      self.$closeFilterOverlay.click(); // close filter drawer
    });
    self.$clearAllButton.on('click', function (e) {
      //console.log('Clearing Filters');
      self.$checkboxesContainer.each(function (i, checkbox) {
        // Connect onChange to Filter input[type"checkbox"]'s
        if ($(checkbox).prop("checked")) {
          $(checkbox).prop("checked", false);
        }
      });
      self.checkCheckedInputs();
      self.updateProductPoints();
      self.updateCollectionPoints();
      self.updateUrl();
    });
    self.initFilterSlider();
  };
  /**
  * Init Filter slider
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.initFilterSlider = function () {
    // Scope it
    var self = this;
    var templateWrapper = $("[data-collection-all='template-wrapper']"); // Handle trigger onclick

    $("[data-collection-all-filter='trigger']").on('click', function (event) {
      // Check if templateWrapper has class 'filters__open'
      if (templateWrapper.hasClass('filters__open')) {
        // If templateWrapper has class 'filters__open'
        // Remove class 'filters__open' from templateWrapper
        templateWrapper.removeClass('filters__open'); // Remove class 'no_scroll__lg' from body

        $('body').removeClass('no_scroll__max-lg');
      } else {
        // If templateWrapper doesn't have class 'filters__open'
        // Check if clicked trigger isn't the wrapper
        if ($(event.target).data('collection-all') != 'template-wrapper') {
          // If clicked trigger isn't the wrapper
          // Add class 'filters__open' to templateWrapper
          templateWrapper.addClass('filters__open'); // 'filters__open' will open/show up the filter mobile panel
          // Add class 'no_scroll__lg' to body

          $('body').addClass('no_scroll__max-lg'); // 'no_scroll__lg' will make body unscrollable when screen smaller lg
        }
      }
    }) // Make sure children don't open the filter
    .children().on('click', function (event) {
      event.stopPropagation();
    });
  };
  /**
  * Check Url paramString and check the correct checkbox.
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.readUrlParams = function () {
    //console.log('readUrlParams')
    var self = this;
    var paramArr = [];
    self.nonFilterParameters = []; // Get filter params from URL

    if (window.location.search.length > 0) {
      paramArr = window.location.search.replace('?', '').split('&');
    } // Fill self.$paramObj with the correct parameters


    paramArr.forEach(function (paramString, i) {
      // Split the paramString into the filterClass and filterValue
      var filterClass = paramString.split('=')[0];
      var filterValue = paramString.split('=')[1].split("+"); // Check if filterClass is an actually a filterClass

      if (self.$filterClasses.indexOf(filterClass) != -1) {
        // If filterClass is an actually a filterClass
        // Set filterClass: filterValue in self.$paramObj
        self.$paramObj[filterClass] = filterValue;
      } else if (paramString.includes('=') && self.$filterClasses.indexOf(filterClass) == -1) {
        self.nonFilterParameters.push(paramString);
      }
    }); // Check the checked checkboxes

    Object.keys(self.$paramObj).forEach(function (filterClass, i) {
      // For all filterClass values
      self.$paramObj[filterClass].forEach(function (value, i) {
        // Find the correct input[type"checkbox"] and set checked to true
        $('[data-filter-finder=' + filterClass + value + ']').prop('checked', true);
      });
    });
    self.checkCheckedInputs();
    self.updateProductPoints();
    self.updateCollectionPoints();
  };
  /**
  * check category inputs
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.checkCheckedInputs = function () {
    //console.log('checkCheckedInputs')
    var self = this; // Get needed Local variables

    self.$pointsNeeded = 0;
    self.$selectedTags = []; // Check input[type"checkbox"]'s per filterClass

    self.$filterClasses.forEach(function (filterClass) {
      // clear params for current filterClass
      self.$paramObj[filterClass] = [];
      var hasCheckedCheckbox = false; // Check input[type"checkbox"]'s of current filterClass

      $('[data-filter-class=' + filterClass + ']').each(function (i, checkbox) {
        // Check if current input[type"checkbox"] is checked
        if ($(checkbox).prop('checked')) {
          // If current input[type"checkbox"] is checked
          self.$paramObj[filterClass].push($(checkbox).data('filter-tag').split(':')[1]); // Set hasCheckedCheckbox to true

          hasCheckedCheckbox = true; // Add selected tag to self.$selectedTags array

          self.$selectedTags.push($(checkbox).data('filter-tag'));
        }
      }); // If filterClass hasCheckedCheckbox

      if (hasCheckedCheckbox) {
        // Add a point to the amount of needed points
        self.$pointsNeeded += 1;
      }
      //console.log(this)
      //console.log(self.$pointsNeeded)
      //console.log('hasCheckedCheckbox = ' + hasCheckedCheckbox)
    });
  };
  /**
  * check if products have the correct amount of points assigned
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.updateProductPoints = function () {
    //console.log('updateProductPoints')
    //console.log(this)
    var self = this; // Handle points for all products

    self.$products.each(function (i, productLink) {
      productLink = $(productLink);
      var newPoints = 0;
      var checkedCategories = [];
      var productTags = productLink.data('collection-product-tags'); // Iterate over all tags the product has (productTags)

      productTags.forEach(function (tag, i) {
        var tagCategorie = tag.split(':')[0];
        /* //console.log('----------');
        //console.log(tagCategorie); */
        // Check If tagCategorie is a checkedCategorie && if Tag is a seleclectedTag

        if (checkedCategories.indexOf(tagCategorie) == -1 && self.$selectedTags.indexOf(tag) != -1) {
          // If tagCategorie is a checkedCategorie && if Tag is a seleclectedTag
          checkedCategories.push(tagCategorie);
          newPoints += 1;
        }
      }); // Assign new amount of point to productLink data-collection-product-points

      productLink.attr('data-collection-product-points', newPoints); // Check if productLink has enough points to be displayed

      if (newPoints < self.$pointsNeeded) {
        // If productLink has enough points to be displayed
        productLink.removeClass('showing');
      } else {
        // If productLink doens't has enough points to be displayed
        productLink.addClass('showing');
      }
      //console.log(productLink)
    });
  };
  /**
  * check if collection have the correct amount of points assigned
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.updateCollectionPoints = function () {
    //console.log('updateCollectionPoints')
    var self = this;
    var collectionsShowing = true; // Iterate over collections

    self.$collections.each(function (i, collection) {
      collection = $(collection);
      var bannerImgMobile = collection.find('.banner-img-mobile'); ////console.log('bannerImgMobile:', bannerImgMobile);

      var modifier = 1;

      if (bannerImgMobile.length > 0) {
        // Check if window is smaller than 1024px
        if ($(window).width() < 1024) {
          // If window is SMALLER than 1024px
          // Add 'showing' to banner-img-mobile
          bannerImgMobile.addClass('showing');
        } else {
          // If window is BIGGER than 1024px
          // Remove 'showing' and 'IE-grid__' from banner-img-mobile
          self.removeClass(bannerImgMobile, 'IE-grid__');
          bannerImgMobile.removeClass('showing');
        }
      } // Handle linked products in collection


      self.handleLinkedProducts(collection); // Get showingProducts in the collection

      var showingProducts = collection.find('.showing:not(".banner-img-mobile")'); // Check if showingProducts

      if (showingProducts.length > 0) {
        // If collection contains showingProducts
        // Iterate over showingProducts
        showingProducts.each(function (index, element) {
          // Check if index == 3 (aka 4th grid position)
          if (index == 3 && bannerImgMobile.hasClass('showing')) {
            // If index == 3 (aka 4th grid position)
            // Assign bannerImgMobile that position by adding the 'IE-grid__' class
            bannerImgMobile.addClass('IE-grid__' + (index + modifier) + ''); // Modify the modifier

            modifier += 1;
          } // Remove old 'IE-grid__' class


          self.removeClass(element, 'IE-grid__'); // Add new 'IE-grid__' class

          $(element).addClass('IE-grid__' + (index + modifier) + '');
        }); // If collection contains showingProducts
        // Add 'showing' class to collection

        collection.addClass('showing');
      } else {
        // If collection doesn't contain showingProducts
        // Remove 'showing' class from collection
        collection.removeClass('showing'); // Set collectionsShowing to false

        collectionsShowing = false;
      }
    }); // Check if none of the collections has showingProducts

    if (!collectionsShowing) {
      // If none of the collections has showingProducts
      // Show the '.no-products-text' by adding 'showing' class to '.no-products-text'
      $('.no-products-text').addClass('showing');
    } else {
      // If one of the collections has showingProducts
      // Hide the '.no-products-text' by removing 'showing' class from '.no-products-text'
      $('.no-products-text').removeClass('showing');
    }
  };
  /**
  * check if collection will show
  *
  * @return bool
  * @access public
  */


  collectionFilter_plugin.prototype.showCollection = function (collection) {
    //console.log('showCollection')
    var self = this; // Check if collection contains '.showing:not(".banner-img-mobile")'

    if (collection.find('.showing:not(".banner-img-mobile")').length != 0) {
      // If collection contains '.showing:not(".banner-img-mobile")'
      // Return true
      return true;
    } else {
      // If collection doesn't contain '.showing:not(".banner-img-mobile")'
      // Return false
      return false;
    }
  };
  /**
  * init Linked Products logic
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.initLinkedProducts = function () {
    //console.log('initLinkedProducts')
    var self = this; // Iterate over collections to check if linkedProducts

    self.$collections.each(function (i, collection) {
      collection = $(collection);
      var linkedProducts = collection.find('[data-collection-product-link]'); // Check if linkedProducts

      if (linkedProducts.length > 0) {
        // If linkedProducts Iterate over linkedProducts to check if linkedProductsCollection is showing
        linkedProducts.each(function (index, linkedProduct) {
          // Get linkedProduct tags
          var currentTags = $(linkedProduct).data('collection-product-tags'); // Get categoryTag

          var tagKey = $('[data-collection-filter-category-tag]').data('collection-filter-category-tag'); // Assign new tag

          var newTag = "" + tagKey + "" + collection.data('collection-wrapper') + ""; // Check if newTag isn't included in currentTags;

          if (currentTags.indexOf(newTag) == -1) {
            // If newTag isn't included in currentTags;
            // Add newTag to currentTags
            currentTags[currentTags.length] = newTag; // Remove other collection from currentTags

            currentTags['0'] = ''; // Set set currentTags as linkedProduct data attribute

            $(linkedProduct).attr('data-collection-product-tags', currentTags);
          }
        });
      }
    });
  };
  /**
  * handle Linked Products logic
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.handleLinkedProducts = function (collection) {
    //console.log('handleLinkedProducts')
    var self = this; // Get linkedProducts from collection

    var linkedProducts = collection.find('[data-collection-product-link]'); // Check if linkedProducts in collection

    if (linkedProducts.length > 0) {
      // If linkedProducts in collection
      // Iterate over linkedProducts
      linkedProducts.each(function (index, linkedProduct) {
        // Remove 'IE-grid__' from linkedProduct
        self.removeClass(linkedProduct, 'IE-grid__'); // Get linkedCollectionHandle from linkedProduct

        var linkedCollectionHandle = $(linkedProduct).data('collection-product-link'); // Find data-collection-wrapper with the correct linkedCollectionHandle and
        // Check if collection is shown

        if (self.showCollection($('[data-collection-wrapper=' + linkedCollectionHandle + ']'))) {
          // If collection is shown
          // Add 'cant_be_showing' class to linkedProduct
          $(linkedProduct).addClass('cant_be_showing'); // 'cant_be_showing' class makes sure that even 'showing' class is added product won't show
        } else {
          // If collection isn't shown
          // Remove 'cant_be_showing' class from linkedProduct
          $(linkedProduct).removeClass('cant_be_showing');
        }
      });
    }
  };
  /**
  * remove class
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.removeClass = function (element, classnamePart) {
    //console.log('removeClass')
    var self = this;
    var newClasses = []; // Get all classes
    var currentClasses = $(element).attr('class').split(' '); // Iterate over current_classes

    currentClasses.forEach(function (classname) {
      // Check if classname doesn't contain classnamePart
      if (classname.indexOf(classnamePart) == -1) {
        // If classname doesn't contain classnamePart
        // Add classname to newClasses
        newClasses.push(classname);
      }
    }); // Fill element attribute class with newClasses

    $(element).attr('class', newClasses.join(' '));
  };
  /**
  * update Url to match filters
  *
  * @return void
  * @access public
  */


  collectionFilter_plugin.prototype.updateUrl = function () {
    //console.log('updateUrl')
    var self = this;
    var URL = window.location.href.split("?")[0];
    var filter_URL = "";
    var isFirstUrlParam = true; // Iterate over the keys in the paramObj

    Object.keys(self.$paramObj).forEach(function (key, i) {
      // Check if this key has content
      if (self.$paramObj[key].length > 0) {
        // If this key has content
        // Check if the 1st parameter
        if (isFirstUrlParam) {
          // If the 1st parameter
          // Set isFirstUrlParam to false
          isFirstUrlParam = false; // Assign filter url

          filter_URL = ["?", filter_URL, key, "=", self.$paramObj[key].join("+")].join('');
        } else {
          // If isn't the 1st parameter
          // Assign filter url
          filter_URL = [filter_URL, "&", key, "=", self.$paramObj[key].join("+")].join('');
        }
      }
    }); // Assign URL with filters

    URL = '' + URL + filter_URL + ''; // self.nonFilterParameters

    for (var i = 0; i < self.nonFilterParameters.length; i++) {
      var parameter = self.nonFilterParameters[i];
      //console.log(parameter);

      if (URL.includes('?')) {
        URL = URL + '&' + parameter;
      } else {
        URL = URL + '?' + parameter;
      }
    } // Set URL in addressbar


    window.history.replaceState(history.state, '', URL);
  };
  /**
  * collectionFilter plugin
  *
  * @return jQuery objects
  */


  $.fn.collectionFilter = function (options) {
    //console.log('collectionFilter')
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collectionFilter_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * Collection template
 ****************************************************************/

$.collectionInit = function () {
  //console.log('collectionInit')
  // Init Ajax pagination
  //$('[data-ajax-pagination]').ajaxPagination(); // Init collection navigation //deleted - wrong working when history.back()

  $('body').collectionNav(); // Init collection filter
  $('[data-colection-filter-wrapper]').collectionFilter(); // Custom filter on collection page
};

$.collectionInit();

//displays sale badge percent
(function() {
  const productCardwrappers = document.querySelectorAll('.ProductItem__Wrapper');
  productCardwrappers.forEach(wrapper => {
    const priceEl = wrapper.querySelector('.ProductItem__Price.Price.Price--compareAt[data-sale-percent]');
    const labelEl = wrapper.querySelector('.ProductItem__Label.SaleLabel');
    if (!priceEl || !labelEl) return;
    const pct = priceEl.getAttribute('data-sale-percent');
    if (!pct) return;
    labelEl.textContent = labelEl.textContent + ` ${pct}%`;
  });
})();


//add products json from link

/*

const url = "https://krakatau.tech/shopify-cmb.json";
async function readJsonFile() {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Status err: ${response.status}`);
    }
    const jsonData = await response.json();
    //console.log(jsonData.products);

    productDataInit(jsonData.products);

    //document.getElementById('added-products').innerText = jsonData;
  } catch (error) {
    console.error("Read err:", error);
  }
}

readJsonFile();


function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

function numberWithSpaces(val) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
}

function priceFormat(val) {
  var p = (String(val)).slice(0, -2);
  return p
}

function sizeAddToCartRedirect(variantId, productHandle) {
  window.location.href = 'https://krakatauwear.com/products/' + productHandle + '?variant=' + variantId;
}

function productDataInit(data){
  for (key in data) {
    //console.log (data[key].id)

    var formatedPrice =  priceFormat(data[key].variants[0].price), formatedPrice = numberWithSpaces(formatedPrice) + ' ₽';
    var formatedComparePrice =  priceFormat(data[key].variants[0].compare_at_price), formatedComparePrice = numberWithSpaces(formatedComparePrice) + ' ₽';
    var formatedPartialPrice =  priceFormat(data[key].variants[0].price) / 4, formatedPartialPrice = Math.round(formatedPartialPrice), formatedPartialPrice = numberWithSpaces(formatedPartialPrice) + ' ₽';

    let randomNum = getRandomInt(1000, 1000000);
    let randomDivId = data[key].id + '-item-' + randomNum;
    let imagesList = '';
    let imageItemCounter = 0;
    let imageCounter = 0;
    let productSizesHtml = '';

    data[key].variants.forEach((item) => {
      //console.log(item)
      var spanClass = item.inventory_quantity > 0 ? 'variant-enabled' : 'variant-disabled';
      var itemTitle = '';
      if(item.title == 'Default Title'){
        itemTitle = 'Универсальный размер';
      }else{
        itemTitle = item.title;
      }
      productSizesHtml += '<span onclick="sizeAddToCartRedirect(' + item.id + ',' + '\'' + data[key].handle + '\'' + ')" data-variant-id=\"' + item.id + '" class=\"' + spanClass + '\">' + item.title + '</span>';
    });

    data[key].images.forEach((item) => {
      if ((item.alt === null) && (imageCounter)) {
        imagesList += '<div class=\"carousel-cell with-counter\"><a class=\"ProductItem__ProductLink\" href=\"https://krakatauwear.com/products/' + data[key].handle + '\"><img class=\"ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn\" data-src=\"' + item.src + '\" data-widths=\"[200,300,400,500,600,800,900,1000,1200]\" data-sizes=\"auto\" alt=\"\" data-image-id=\"' + (item.position - 1) + '\" loading=\"lazy\"></a></div>';
        imageItemCounter++;
      }
      imageCounter++;
    });

    let htmlTemplate = '<div class=\"ProductItem \" data-product-id=\"' + data[key].id + '\" data-product-url=\"' + data[key].url + '\" style=\"visibility: inherit;opacity: 1;transform: matrix(1, 0, 0, 1, 0, 0);\"><div class=\"ProductItem__Wrapper\"><div class=\"ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage\"><div class=\"aspect-info AspectRatio AspectRatio--withFallback\" style=\"--aspect-ratio: 0.705\">';
    htmlTemplate += '<div id=\"' + randomDivId + '\" class=\"carousel\" data-flickity=\"{ \'groupCells\': false, \'prevNextButtons\': false, \'watchCSS\': true }\">';
    htmlTemplate += imagesList;
    htmlTemplate += '</div>';
    htmlTemplate += '<span class=\"images-counter\">1/' + imageItemCounter + '</span>';
    htmlTemplate += '<img class=\"ProductItem__Image Image--lazyLoad Image--fadeIn first-image\" data-src=\"' + data[key].image.src + '\" data-widths=\"[200,300,400,500,600,800,900,1000,1200]\" data-sizes=\"auto\" alt=\"" data-image-id=\"' + data[key].image.id + '\" loading=\"lazy\">';
    htmlTemplate += '<span class=\"Image__Loader\"></span>';
    htmlTemplate += '</div>';
    htmlTemplate += '<div class=\"ProductItem__LabelList\"><span class=\"ProductItem__Label Text--subdued\">Sold Out</span></div>';
    htmlTemplate += '</div>';
    htmlTemplate += '<div class=\"ProductItem__Info product-link ProductItem__Info--left\"><div class=\"item-product-variants-wrap\" style=\"bottom: 30px\">';
    htmlTemplate += '<script type=\"application/json\" data-variants-json> + itemInsertedVariantJson + TODO</script>';
    htmlTemplate += '<ul class=\"color-swatch\">';
    //htmlTemplate += colorVariantsList;
    htmlTemplate += '</ul></div>';
    htmlTemplate += '<div class=\"item-product-variants-sizes\">';
    htmlTemplate += productSizesHtml;
    htmlTemplate += '</div>';
    htmlTemplate += '<h2 class=\"ProductItem__Title\"><a href=\"https://krakatauwear.com/products/' + data[key].handle + '\">' + data[key].title + '</a></h2>';
    htmlTemplate += '<div class=\"ProductItem__PriceList\">';

    data[key].compare_at_price ?
    htmlTemplate += '<span class="ProductItem__Price Price Price--highlight Text--subdued">' + formatedPrice + '</span><span class="ProductItem__Price Price Price--compareAt Text--subdued">' + formatedComparePrice + '</span><br><span class="ProductItem__Price Price Price--partial">' + formatedPartialPrice + '</span><span class="ProductItem__Price Price Price--partial-text"> ✕ 4 долями</span>'
    : htmlTemplate += '<span class="ProductItem__Price Price Text--subdued">' + formatedPrice + '</span><br><span class="ProductItem__Price Price Price--partial">' + formatedPartialPrice + '</span><span class="ProductItem__Price Price Price--partial-text"> ✕ 4 долями</span>';

    htmlTemplate += '</div></div></div></div>';

    var targetDiv = document.getElementById('product-grid');
    var newDiv = document.createElement('div');
    const classesNewDiv = ['product-link-wrapper', 'Grid__Cell', '1/2--phone', '1/2--tablet-and-up', '1/4--lap-and-up', 'showing', 'IE-grid__3'];

    newDiv.classList.add(...classesNewDiv)
    newDiv.setAttribute("data-collection-product-tags", "TODO");
    newDiv.setAttribute("data-collection-product-wrapper", data[key].handle);
    newDiv.setAttribute("data-collection-product-points", 0);
    newDiv.setAttribute("data-collection-product-number", '');
    newDiv.innerHTML = htmlTemplate;

    targetDiv.appendChild(newDiv);

    var testDiv = document.getElementById(randomDivId);
    var flicityStart = new Flickity(testDiv);
  }
}

*/